export const WorldIcon = () => (
  <img width={24} height={24} src="/assets/images/m_world.png" alt="world" />
);
